<ui-card [loading]="isLoading">
    <app-segment-header
        title="time-off-v3.policyComponents.amountAccruedPerYear.amountAccruedPerYear"
    ></app-segment-header>

    <div class="flex col">
        <h4>
            {{
                'time-off-v3.policyComponents.amountAccruedPerYear.howManyUnitWillEmployeesReceive'
                    | translate: { unit: unitOfTime | translate | lowercase }
            }}
        </h4>
        <mat-form-field class="restricted-width-wide">
            <mat-label class="neutral-darker">{{
                'time-off-v3.policyComponents.amountAccruedPerYear.baseAccrualPerYear' | translate
            }}</mat-label>
            <input
                name="amountAccruedPerYear"
                [textMask]="{ mask: numberMask }"
                [min]="0"
                placeholder="0"
                required
                matInput
                [ngModel]="formatLocalizedNumber(days)"
                (ngModelChange)="days = parseLocalizedNumber($event); onAmountAccruedPerYearChange()"
                #daysAccruedPerPeriod="ngModel"
            />
            <span matSuffix>{{ unitOfTime | translate | lowercase }}</span>

            <mat-error *ngIf="daysAccruedPerPeriod.invalid"> {{ daysAccruedPerPeriod.errors | formErrors }} </mat-error>
        </mat-form-field>

        <h4 class="margin-top-1">{{ 'time-off-v3.seniorityIncrease' | translate }}</h4>
        <p class="neutral-darker">
            {{
                'time-off-v3.policyComponents.amountAccruedPerYear.theAmountAccruedPerYearWillAutomatically' | translate
            }}
        </p>

        <ng-container *ngFor="let seniorityOverride of timeOffSeniorityOverrides; let i = index">
            <div class="flex row">
                <div class="flex middle">
                    <p class="no-margin-bottom">{{ 'time-off-v3.after' | translate }}</p>
                    <mat-form-field class="margin-left-1 field-width">
                        <input
                            [ngModel]="seniorityOverride.getLocalizedProperty('afterNumberOfYears')"
                            (ngModelChange)="seniorityOverride.setLocalizedProperty('afterNumberOfYears', $event)"
                            name="year_{{ i }}"
                            #year="ngModel"
                            placeholder="0"
                            [textMask]="{ mask: numberMask }"
                            required
                            matInput
                            [min]="0"
                        />
                        <span matSuffix>{{ 'time-off-v3.years' | translate | lowercase }}</span>
                        <mat-error *ngIf="year.invalid">{{ year.errors | formErrors }}</mat-error>
                    </mat-form-field>
                    <p class="margin-left-1">
                        {{
                            'time-off-v3.policyComponents.amountAccruedPerYear.increaseAmountAccruedPerYearTo'
                                | translate
                        }}
                    </p>
                </div>
                <div class="flex middle">
                    <mat-form-field class="margin-left-1 field-width">
                        <input
                            [ngModel]="formatLocalizedNumber(getDaysAccruedPerPeriod(seniorityOverride))"
                            (ngModelChange)="setDaysAccruedPerPeriod(seniorityOverride, parseLocalizedNumber($event))"
                            name="daysAccrued_{{ i }}"
                            #daysAccrued="ngModel"
                            placeholder="0"
                            required
                            matInput
                            [min]="0"
                            [textMask]="{ mask: numberMask }"
                        />
                        <span matSuffix>{{ unitOfTime | translate | lowercase }}</span>
                        <mat-hint align="end"
                            >{{ getAccruedValuePerPeriod(seniorityOverride.daysAccruedPerPeriod) | i18nNum: 'no$' }}
                            {{ timeOffPolicy.timeOffType.unitOfTimePluralTranslation | translate }}
                            {{ 'time-off-v3.policyComponents.amountAccruedPerYear.perPeriod' | translate }}</mat-hint
                        >
                        <mat-error *ngIf="daysAccrued.invalid">{{ daysAccrued.errors | formErrors }}</mat-error>
                    </mat-form-field>
                    <ui-button (click)="removeSeniorityOverride(i)" type="ghost" class="margin-left-1"
                        ><mat-icon svgIcon="trash"></mat-icon
                    ></ui-button>
                </div>
            </div>
        </ng-container>
        <div>
            <ui-button (click)="addSeniorityOverride()" type="outline"
                ><mat-icon svgIcon="plus"></mat-icon
                >{{ 'time-off-v3.policyComponents.amountAccruedPerYear.addLevel' | translate }}</ui-button
            >
        </div>
    </div>
</ui-card>
